import React, { useContext, useEffect, useState } from 'react';
import HomePageCtx from './HomePageCtx';
import { ExpandableSection, Icon, Box, Button } from '@amzn/awsui-components-core';
import { getFilterOptionsKeys } from '../../utils/ContentFilterUtils';

const SelectedPublicationFilters = () => {
  const { setFilterOptions, filterOptions } = useContext(HomePageCtx);
  const [selectedFiltersNumber, setSelectedFiltersNumber] = useState(0);

  useEffect(() => {
    renderSelectedFilters();
  }, [filterOptions]); // eslint-disable-line react-hooks/exhaustive-deps

  const deselectFilterOption = (filterSectionId: string, filterOptionKey: string) => {
    const filterSection = filterOptions[filterSectionId];
    // @ts-expect-error TS18048 - strict migration
    if (filterSection.options[filterOptionKey]) {
      // @ts-expect-error TS18048 - strict migration
      filterSection.options[filterOptionKey].selected = false;
      setFilterOptions({ ...filterOptions });
    }
  };

  const renderSelectedFilters = () => {
    let currentSelectedFiltersNumber = 0;
    const selectedFilters = (
      <div className="home-page-selcted-filters-container">
        {Object.keys(filterOptions).map((filterSectionId) => {
          const filter = filterOptions[filterSectionId];
          if (!Object.keys(filter?.options || {}).length) {
            return null;
          }
          // @ts-expect-error TS2339 - strict migration
          const { options } = filter;
          const filterOptionsKeys = getFilterOptionsKeys(options);
          return filterOptionsKeys.map((optionKey) => {
            const filterOption = options[optionKey];
            if (filterOption.selected) {
              currentSelectedFiltersNumber += 1;
              return (
                <div key={optionKey} className="home-page-selected-filter">
                  <div className="home-page-selected-filter-label">{filterOption.label}</div>
                  <Button
                    variant="icon"
                    iconName="close"
                    ariaLabel="Remove filter"
                    onClick={deselectFilterOption.bind(this, filterSectionId, optionKey)}
                  />
                </div>
              );
            } else {
              return null;
            }
          });
        })}
      </div>
    );
    if (selectedFiltersNumber !== currentSelectedFiltersNumber) {
      setSelectedFiltersNumber(currentSelectedFiltersNumber);
    }
    if (!selectedFiltersNumber) {
      return null;
    }
    return selectedFilters;
  };

  const handleClearFilterClick = () => {
    Object.values(filterOptions).forEach((filter) => {
      if (filter) {
        filter.expanded = true;
        Object.values(filter.options).forEach((option) => (option.selected = false));
      }
    });
    setFilterOptions({ ...filterOptions });
  };

  const selectedFiltersHeader = (
    <div className="home-page-selected-filters-header-container">
      <div className="home-page-selected-filters-header-number">
        Selected filters
        <Box
          color="text-body-secondary"
          padding={{ left: 'xs' }}
        >{`(${selectedFiltersNumber})`}</Box>
      </div>
      <Button
        iconName="close"
        variant="icon"
        ariaLabel="Clear all filters"
        onClick={handleClearFilterClick}
      />
    </div>
  );

  if (!selectedFiltersNumber) {
    return null;
  }

  return (
    <ExpandableSection header={selectedFiltersHeader} defaultExpanded={!!selectedFiltersNumber}>
      {renderSelectedFilters()}
    </ExpandableSection>
  );
};

export default SelectedPublicationFilters;
